import React from 'react'
import { Button } from '@/components/ui/button'
import { Cross2Icon, HamburgerMenuIcon } from '@radix-ui/react-icons'
import { Link, useLocation } from 'react-router-dom'
import LogoVITE from "@/assets/images/Vite_White_Remove_Bg.png";
import ThemeToggle from '@/components/common/ThemeToggle';

const DashboardHeader = ({ toggleResponsiveSidebar, setToggleResponsiveSidebar, setCurrentNode }) => {
  const { pathname } = useLocation();
  const paths = pathname.split('/').filter((path) => path !== '');
  const role = localStorage.getItem('role');
  return (
    <header className={`px-5 py-2 fixed  top-0 transition-all duration-300 dashboard-header  w-full bg-theme !z-[8889] `}>
      <div className="flex items-center  justify-between">
        <div className='flex justify-start items-center gap-2'>
          <div className="logo-part lg:hidden block">
            <Link to={"/research-notes"}>
              <img src={LogoVITE} alt='logo' className='w-[150px] h-[40px]' />
            </Link>
          </div>
          <div className="logo-part hidden lg:block">
            <Link to={"/research-notes"}>
              <img src={LogoVITE} alt='logo' className='h-[40px]' />
            </Link>
          </div>

        </div>
        <div className='ps-24'>
          {role === "user" && <ul className='flex justify-start items-center gap-x-3  text-[14px]'>
            <Link to="/sentry" >
              <li onClick={() => setCurrentNode("sentry")} className={`relative px-2 py-1 text-gray-100 hover:text-white after:absolute after:left-[50%] after:-translate-x-1/2 after:bottom-0 after:w-[75%] after:h-[1px] after:bg-transparent hover:after:bg-white focus:outline-none focus:after:bg-white cursor-pointer ${paths?.includes("sentry") && "after:bg-white"}`}>Sentry</li>
            </Link>
            <Link to="/data/asset" >
              <li onClick={() => setCurrentNode("data")} className={`relative px-2 py-1 text-gray-100 hover:text-white after:absolute after:left-[50%] after:-translate-x-1/2 after:bottom-0 after:w-[75%] after:h-[1px] after:bg-transparent hover:after:bg-white focus:outline-none focus:after:bg-white cursor-pointer ${paths?.includes("data") && "after:bg-white"} `}>Data</li>
            </Link>
          </ul>}
        </div>
        <div className="flex items-center gap-2">
          <Button className="w-8 h-8 p-0 lg:hidden flex" onClick={() => setToggleResponsiveSidebar(!toggleResponsiveSidebar)}>
            {
              toggleResponsiveSidebar ? <Cross2Icon /> : <HamburgerMenuIcon />
            }
          </Button>
          <div className="">
            <ThemeToggle />
          </div>
        </div>
      </div>
    </header>
  )
}

export default DashboardHeader